import * as initConfig from './initConfigDataHandler';
import * as getToolbarTitle from './getToolbarTitleHandler';
import * as setEntryPoint from './setEntryPointHandler';
import * as navigateBack from './navigateBackHandler';
import * as searchClicked from './searchClickedHandler';
import * as navigateHome from './navigateHomeHandler';
import * as navigate from './navigateHandler';

const imports = [
  initConfig,
  getToolbarTitle,
  setEntryPoint,
  navigateBack,
  navigateHome,
  navigate,
  searchClicked,
];
const handlers = {};
imports.forEach(e => (handlers[e.handlerName] = e.handler));

export default handlers;
